module.exports = __webpack_public_path__ + "img/161cb05e9e72282f25cf5379cb87e884.png";